import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonSelect from "../../../components/forms/CommonSelect";
import { handleChange } from "../../../helpers/handleFormChanges";
import CommonTextArea from "../../../components/forms/CommonTextArea";
import CommonInput from "../../../components/forms/CommonInput";
import CommonButton from "../../../components/buttons/CommonButton";
import PropTypes from "prop-types";

function EnviarModal({
  isOpen,
  setIsOpen,
  valuesHook,
  modelos,
  modelo,
  enviarMensagens,
}) {
  const { values, setValues } = valuesHook;

  return (
    <CommonModal
      title={"Enviar WhatsApp"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="lg"
      buttons={
        <CommonButton
          onClick={() => {
            enviarMensagens();
          }}
          color="success"
        >
          Enviar WhatsApp
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-md-5 mb-3">
          <div className="col mb-3">
            <CommonSelect
              label="Modelo de mensagem"
              id="modelo"
              value={values.modelo}
              onChange={(e) => {
                handleChange(e, values, setValues);
              }}
              data={
                modelos &&
                modelos.map((modelo) => ({
                  text: modelo.nome,
                  id: modelo.uid,
                }))
              }
              placeholder="Selecione um modelo"
              required
            />
          </div>
          <div className="col mb-3">
            <CommonTextArea
              label="Descrição do modelo"
              id="descricao"
              value={modelo?.descricao ? modelo.descricao : ""}
              rows={11}
              disabled
            />
          </div>
        </div>
        <div className="col-md-7">
          {Array.from({ length: modelo.variaveis }, (_, i) => i + 1).map(
            (index) => (
              <div className="row" key={`variavel-${index}`}>
                <div className="col-5 mb-3" key={index}>
                  <CommonSelect
                    label={`Tipo da variável ${index}`}
                    id={`variavel_${index}`}
                    value={values[`variavel_${index}`]}
                    onChange={(e) => {
                      handleChange(e, values, setValues);
                    }}
                    data={[
                      { id: "1", text: "Campo aberto" },
                      { id: "2", text: "Nome contato" },
                      { id: "3", text: "Razão social" },
                      { id: "4", text: "CNPJ" },
                    ]}
                    placeholder="Selecione um tipo"
                    required
                  />
                </div>
                {values[`variavel_${index}`] === "1" ? (
                  <div className="col-7 mb-3">
                    <CommonInput
                      label={`Valor da variável ${index}`}
                      id={`valor_variavel_${index}`}
                      value={values[`valor_variavel_${index}`]}
                      onChange={(e) => {
                        handleChange(e, values, setValues);
                      }}
                      required
                    />
                  </div>
                ) : null}
              </div>
            )
          )}
        </div>
      </div>
    </CommonModal>
  );
}

EnviarModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  modelos: PropTypes.arrayOf(PropTypes.object).isRequired,
  modelo: PropTypes.object.isRequired,
  enviarMensagens: PropTypes.func.isRequired,
};

export default EnviarModal;
